<template>
    <div class="budget-bar" :class="{'warning': maxValue > 0 && block}">
        <div class="percentage-container" v-if="maxValue > 0">
            <div class="percentage-width" :style="{ width: percentageWidth + '%' }"></div>
        </div>
        <div class="budget-text" v-if="maxValue > 0 && value < 0">$<span>O left</span></div>
        <div class="budget-text" v-else-if="maxValue > 0">${{value.toFixed(2).replace(/\.00$/, '')}} <span>left</span></div>
        <div class="budget-text" v-else><span>Current monthly cost: </span><span>{{cost ? cost.toFixed(2).replace(/\.00$/, '') : 0}}$</span></div>
    </div>
</template>



<script>
    
  export default {
        components: {
        },

        props: {
            value: {
                type: Number,
            },
            maxValue: {
                type: Number,
            },
            cost: {
                type: Number,
            },
            block: {
                type: Boolean,
            }
        },

        created() {
        },

        data() {
            return {
                percentageWidth: 0,
                currentCost: 0,
            }
        },

        methods: {

            calcPercentageWidth() {
                this.percentageWidth = (100 / this.maxValue) * this.value;
            },
        },

        mounted() {
            this.currentCost = this.cost | 0;
            this.calcPercentageWidth();

        }
  }

</script>

<style lang="scss">
    .budget-bar {
        .percentage-container {
            position: relative;
            width: 100%;
            height: 4px;
            background-color: #FFFFFF;
            border-radius: 4px;
            margin-bottom: 10px;

            .percentage-width {
                position: absolute;
                left: 0px;
                height: 4px;
                border-radius: 4px;
                background-color: #46AAF6;
            }
        }

        .budget-text {
            font-size: 14px;
            line-height: 16px;
            color: #000000;

            >span,
            >div {
                font-size: 13px;
                line-height: 15px;
                color: #666666;
            }
        }

        &.warning {
            margin-bottom: 0;
            .percentage-container {

                .percentage-width {
                    background-color: #F1533E;
                }
            }

            .budget-text {
                color: #F1533E;
            }

        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Campaign/AppsBudgets/PercentageBar.vue